import { create } from "zustand"
import {FormState, BillDetailTypes} from "../types/billAdjustmentTypes"

interface BillAdjustmentState {
    adj_code: string
    data_bill: BillDetailTypes
    isLoading: boolean
    error: string | null
    total_detail : number
    saldo:number
    data_form: FormState

    // Action
    setAdjCode: (value: string) => void
    setDataFrom: (data_form: Partial<FormState>) => void
    setTotalDetail:(value: number) => void
    setSaldo:(value: number) => void
    setDataBill: (data_bill: BillDetailTypes) => void
    setLoading: (value: boolean) => void
    reset: () => void
}

//Initial state
const initialState: Omit<BillAdjustmentState, 
  | "setAdjCode"
  | "setDataFrom"
  | "setTotalDetail"
  | "setSaldo"
  | "setDataBill"
  | "setLoading"
  | "reset"
> = {
  data_bill: {
    bill_id: 0,
    transaction_date: '',
    trx_code: '',
    purchase_order_id: 0,
    po_code: '',
    bill_status: '',
    bill_status_text: '',
    vendor_id: 0,
    vendor_code: '',
    vendor_name: '',
    employee_id: 0,
    employee_name: '',
    location_id: 0,
    location_name: '',
    freight: 0,
    total_bill: 0,
    total_tax: 0,
    tot_payment: 0,
  },
  data_form: {
    bill_id: 0,
    transaction_date: "",
    adj_freight: 0,
    coa_freight_credit: 0,
    coa_ap_debet: 0,
    coa_freight_credit_name: '',
    coa_ap_debet_name: '',
    employee_id: 0,
    location_id: 0,
    vendor_id:0,
  },
  isLoading: true,
  error: null,
  adj_code: '',
  total_detail: 0,
  saldo: 0,
}


export const adjustmentFreightStore = create<BillAdjustmentState>((set, get) => ({
   ...initialState,

    setAdjCode:(value) => set({ adj_code: value }),
    setTotalDetail:(value) => set({ total_detail: value }),
    setSaldo:(value) => set({ saldo: value }),
    setDataBill: (data_bill) => set({ data_bill }),
    setLoading: (value) => set({ isLoading: value }),
    setDataFrom: (data_form) =>
        set((state) => ({
            data_form: { ...state.data_form, ...data_form },
        })
    ),

    reset: () => set(() => ({ ...initialState })),
}))